var creditcards = require('../creditcards/index');
//var types = require('creditcards-types').types;

angular.module('component-payments.format.number', [])
	.directive('ctPaymentsFormatNumber', paymentsFormatNumberDirective);

function paymentsFormatNumberDirective () {
	return {
		restrict: 'A',
		require: ['ngModel', '^ctPayments'],
		link: function (scope, elem, attrs, ctrls) {
			var NgModelCtrls = ctrls[0],
				CtPaymentsCtrl = ctrls[1],
				isMainCard = 'ctPaymentsMainCard' in attrs;

			NgModelCtrls.$parsers.push(formatter);
			NgModelCtrls.$formatters.push(formatter);

			function formatter(val) {
				var type = creditcards.card.type(val, true);

				if (isMainCard) {
					CtPaymentsCtrl.setCard(type);
				}

				NgModelCtrls.cardType = typeof type == 'string' ? type.toLowerCase() : type;

				return val;
			}
		}
	}
}

module.exports = 'component-payments.format.number';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/formatters/number.js
 ** module id = 94
 ** module chunks = 1
 **/